// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2CellPoint-module__button--oYCLj {
  background: inherit;
  border: none;
  padding: 4px 12px;
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2CellPoint-module__button--oYCLj .src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2CellPoint-module__text--FM5Iq {
  flex: 1;
  text-align: left;
  color: rgba(0, 0, 0, 0.55);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2Table/components/Mc2CellPoint.module.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAAF;AAVA;EAaI,OAAA;EACA,gBAAA;EAEA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ","sourcesContent":[".button {\n  background: inherit;\n  border: none;\n  padding: 4px 12px;\n  width: 100%;\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n\n  .text {\n    flex: 1;\n    text-align: left;\n\n    color: rgba(0, 0, 0, 0.55);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 160%;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2CellPoint-module__button--oYCLj`,
	"text": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-components-Mc2CellPoint-module__text--FM5Iq`
};
export default ___CSS_LOADER_EXPORT___;
